import { render, staticRenderFns } from "./TransferLog.vue?vue&type=template&id=79b620ce&scoped=true&"
import script from "./TransferLog.vue?vue&type=script&lang=js&"
export * from "./TransferLog.vue?vue&type=script&lang=js&"
import style0 from "./TransferLog.vue?vue&type=style&index=0&id=79b620ce&scoped=true&lang=css&"
import style1 from "./TransferLog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b620ce",
  null
  
)

export default component.exports